// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DeletePortfolioRequestFromJSON(json) {
    return {
        'portfolioIds': !exists(json, 'portfolioIds') ? undefined : json['portfolioIds'],
    };
}
export function DeletePortfolioRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'portfolioIds': value.portfolioIds,
    };
}
